import {
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Spacer,
  Spinner,
  VStack,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import UploadMutiFile from "../components/UploadFileShape";
import { ITimTuyenDuong } from "../_types_";
import { getToast } from "../utils";
import { themMoiTimDuong } from "../apis/he.so.dieu.chinh.api";
import { useGlobal } from "../contexts/Globals";

export default function TimTuyenDuongForm() {
  const toast = useToast();
  const { isHasEditRole } = useGlobal();
  const [model, setModel] = useState<ITimTuyenDuong>({});
  const { isOpen, onClose, onOpen } = useDisclosure();

  const handleOnChange = (field: string, value: string | number) => {
    if (!model) return;
    const newModel = { ...model };

    // let val = typeof field === "number" ? Number(str) : str;
    //const newModel = { ...model, [field]: str };
    newModel[field] = value;

    setModel(newModel);
  };

  const handleSave = async () => {
    try {
      if (!model.huyen) {
        return toast(getToast("Vui lòng nhập đầy đủ thông tin."));
      }
      onOpen();
      const rs = await themMoiTimDuong(model);
      toast(getToast("Thêm mới tim đường thành công", "success", "Tim Đường"));
      setModel({});
    } catch (ex: any) {
      toast(getToast(`${ex.error}`, "error", "Tim Đường"));
    }
    onClose();
  };

  return (
    <FormControl>
      <FormLabel>Tên đường :</FormLabel>
      <Input
        bgColor="white"
        value={model?.tenDuong}
        onChange={(e) => handleOnChange("tenDuong", e.target.value)}
      />
      <FormLabel mt="5px">Loại đất :</FormLabel>
      <Input
        bgColor="white"
        value={model?.loaiGt}
        onChange={(e) => handleOnChange("loaiGt", e.target.value)}
      />
      <HStack w="full" mt="5px">
        <VStack flex={1} alignItems="flex-start">
          <FormLabel>Điểm đầu:</FormLabel>
          <Input
            bgColor="white"
            value={model?.diemDau}
            onChange={(e) => handleOnChange("diemDau", e.target.value)}
          />
        </VStack>
        <VStack flex={1} alignItems="flex-start">
          <FormLabel>Điểm cuối:</FormLabel>
          <Input
            bgColor="white"
            value={model?.diemCuoi}
            onChange={(e) => handleOnChange("diemCuoi", e.target.value)}
          />
        </VStack>
        <VStack flex={1} alignItems="flex-start">
          <FormLabel>Hệ số:</FormLabel>
          <Input
            bgColor="white"
            type="number"
            value={model?.heSo}
            onChange={(e) => handleOnChange("heSo", Number(e.target.value))}
          />
        </VStack>
      </HStack>

      <HStack w="full" mt="5px">
        <VStack flex={1} alignItems="flex-start">
          <FormLabel>Vị trí 1:</FormLabel>
          <Input
            bgColor="white"
            type="number"
            value={model?.viTri_1}
            onChange={(e) => handleOnChange("viTri_1", Number(e.target.value))}
          />
        </VStack>
        <VStack flex={1} alignItems="flex-start">
          <FormLabel>Vị trí 2:</FormLabel>
          <Input
            bgColor="white"
            type="number"
            value={model?.viTri_2}
            onChange={(e) => handleOnChange("viTri_2", Number(e.target.value))}
          />
        </VStack>
        <VStack flex={1} alignItems="flex-start">
          <FormLabel>Vị trí 3:</FormLabel>
          <Input
            bgColor="white"
            type="number"
            value={model?.viTri_3}
            onChange={(e) => handleOnChange("viTri_3", Number(e.target.value))}
          />
        </VStack>
        <VStack flex={1} alignItems="flex-start">
          <FormLabel>Vị trí 4:</FormLabel>
          <Input
            bgColor="white"
            type="number"
            value={model?.viTri_4}
            onChange={(e) => handleOnChange("viTri_4", Number(e.target.value))}
          />
        </VStack>
        <VStack flex={1} alignItems="flex-start">
          <FormLabel>Vị trí 5:</FormLabel>
          <Input
            bgColor="white"
            type="number"
            value={model?.viTri_5}
            onChange={(e) => handleOnChange("viTri_5", Number(e.target.value))}
          />
        </VStack>
      </HStack>

      <HStack w="full" mt="5px">
        <VStack flex={1} alignItems="flex-start">
          <FormLabel>Là tuyến đường chính trong BGĐ:</FormLabel>
          <Input
            bgColor="white"
            type="number"
            value={model?.laTuyenDuongChinhTrongBangGiaDat}
            onChange={(e) =>
              handleOnChange(
                "laTuyenDuongChinhTrongBangGiaDat",
                Number(e.target.value)
              )
            }
          />
        </VStack>
        <VStack flex={1} alignItems="flex-start">
          <FormLabel>Loại đường:</FormLabel>
          <Input
            bgColor="white"
            type="number"
            value={model?.loaiDuong}
            onChange={(e) =>
              handleOnChange("loaiDuong", Number(e.target.value))
            }
          />
        </VStack>
      </HStack>

      <HStack w="full" mt="5px" mb="10px">
        <VStack flex={1} alignItems="flex-start">
          <FormLabel>Mã Đơn vị hành chính:</FormLabel>
          <Input
            bgColor="white"
            value={model?.maDVHC}
            onChange={(e) => handleOnChange("maDVHC", Number(e.target.value))}
          />
        </VStack>
        <VStack flex={1} alignItems="flex-start">
          <FormLabel>Huyện:</FormLabel>
          <Input
            bgColor="white"
            value={model?.huyen}
            onChange={(e) => handleOnChange("huyen", e.target.value)}
          />
        </VStack>
      </HStack>
      <UploadMutiFile
        title="Tim tuyến đường"
        isTimTuyenDuong
        onUploadSuccess={(f) => {
          if (model) {
            const newModel = { ...model, geo: f as string };
            setModel(newModel);
          }
        }}
      />

      {isHasEditRole &&   <HStack mt="10px">
        <Spacer />
        <Button
          bg="blue.900"
          borderRadius="0px"
          color="white"
          textTransform="capitalize"
          onClick={handleSave}
          disabled={isOpen}
        >
          {isOpen && <Spinner />}
          {!isOpen && `Lưu tim đường`}
        </Button>
      </HStack>}
    </FormControl>
  );
}
